'use client';
import styled from 'styled-components';

const Wrapper = styled.div`
  max-width: 50rem;
  margin: 0 auto;
  padding: 2.5rem 0 6.25rem 0;
  display: flex;
  flex-direction: column;
  gap: 2.5rem;
  contain: layout style;
`;

export default function SearchResultsWrapper({ children }) {
  return <Wrapper>{children}</Wrapper>;
}
